import { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { CommercialOverviewUsingGetHook } from './types';
import { orderLineController } from 'config/apiFunus';
import { Base64Data } from 'models/Base64Data';
import { MimeTypes } from 'models/Base64Data/MimeTypes';
import { showSuccessToast } from 'utils/toasts';

export const useCommercialOverviewUsingGet = (
  errorMessage: (message: string) => void,
): CommercialOverviewUsingGetHook => {
  const { t } = useTranslation();
  const base64Data = `data:${MimeTypes.APPLICATION_PDF}${Base64Data.BASE64_GLU}`;

  const [comercialBase64, setcomercialBase64] = useState<string>();

  const getComercialPdf = async (erpId: number) => orderLineController
    .commercialOverviewUsingGet(erpId)
    .then((response) => {
      const unit8 = new Uint8Array(response);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const binary = String.fromCharCode.apply(null, unit8 as any);
      const base64 = btoa(binary);
      setcomercialBase64(`${base64Data}${base64}`);

      return `${base64Data}${base64}`;
    })
    .catch((error) => {
      errorMessage(error.message);
      throw error;
    });

  const sendComercialPdf = useCallback(
    async (erpId: string, email: string) => orderLineController
      .commercialOverviewSend(erpId, email)
      .then((response) => {
        showSuccessToast(t('article.flowers.sendComercialSuccess'));
        return response;
      })
      .catch((error) => {
        errorMessage(error.message);
        throw error;
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t],
  );

  return {
    comercialBase64,
    getComercialPdf,
    sendComercialPdf,
  };
};
